<template>
  <div>
    <b-card style="width: 100%; height: 320px; border-radius: 10px;">
      <div>
        <span style="font-size:20px; color: #fff;">ความเร็วเฉลี่ยรายชั่วโมง</span>
      </div>

      <div
        v-if="loading"
        class="loading-container"
      >
        <b-spinner
          variant="danger"
          label="Loading..."
        />
        <span class="loading-text">กำลังโหลดข้อมูล...</span>
      </div>

      <div
        v-else-if="error"
        class="error-container"
      >
        {{ error }}
        <b-button
          size="sm"
          variant="outline-danger"
          @click="getSpeedData"
        >
          ลองใหม่
        </b-button>
      </div>

      <app-echart-line
        v-else
        style="height: 270px;"
        :option-data="option"
      />
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import {
  BCard,
  VBModal,
  BSpinner,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AppEchartLine from './AppEchartLine.vue'

export default {
  name: 'SpeedChart',

  components: {
    BCard,
    AppEchartLine,
    BSpinner,
    BButton,
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  data() {
    return {
      loading: false,
      error: null,
      interval: null,
      xAxisData: [],
      option: {
        xAxisData: [],
        series: [
          {
            name: 'ความเร็วเฉลี่ย',
            type: 'line',
            data: [],
            color: '#fe5c5c',
            showSymbol: false,
          },
        ],
      },
    }
  },

  mounted() {
    this.initializeChart()
  },

  beforeDestroy() {
    this.clearInterval()
  },

  methods: {
    initializeChart() {
      this.getSpeedData()
      this.startInterval()
    },

    startInterval() {
      this.clearInterval()
      this.interval = setInterval(() => {
        this.getSpeedData()
      }, 300000) // 5 minutes
    },

    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    async getSpeedData() {
      if (this.loading) return

      this.loading = true
      this.error = null

      try {
        const response = await axios.post(
          'https://wts.drr.go.th/node-red/get-Speed-Hourly-WIM',
          { wid: this.$route.query.wid },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            timeout: 10000,
          },
        )

        // Clear existing data
        this.xAxisData = []
        this.option.xAxisData.splice(0)
        this.option.series[0].data.splice(0)

        // Update with new data
        this.xAxisData = response.data
        this.xAxisData.forEach(value => {
          this.option.xAxisData.push(value.Period_Name)
          this.option.series[0].data.push(value.avg_speed)
        })
      } catch (error) {
        console.error('Error fetching speed data:', error)
        this.error = 'ไม่สามารถโหลดข้อมูลได้'
        setTimeout(() => {
          this.getSpeedData()
        }, 30000) // Retry after 30 seconds
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

 <style scoped>
 .loading-container,
 .error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 270px;
  color: #fff;
  gap: 1rem;
 }

 .loading-text {
  margin-top: 0.5rem;
 }
 </style>
